import { RichTableResizerComponent } from './column-resizer.js';
import { RichTableBlockComponent } from './rich-table-block.js';
import { RichTableCellBlockComponent } from './rich-table-cell.js';
import { RichTableRowBlockComponent } from './rich-table-row.js';

const define = (name: string, element: CustomElementConstructor) => {
  // The view extension's effect() can run more than once in tests and in
  // multi-editor hosts; redefining a custom element throws.
  if (!customElements.get(name)) {
    customElements.define(name, element);
  }
};

export function effects() {
  define('affine-rich-table', RichTableBlockComponent);
  define('affine-rich-table-row', RichTableRowBlockComponent);
  define('affine-rich-table-cell', RichTableCellBlockComponent);
  define('affine-rich-table-resizer', RichTableResizerComponent);
}
